import React from "react";
import "../../styles-v2/skeleton/v2-skeleton.css";

/**
 * Basic Skeleton Loader Component
 */
export const Skeleton = ({ width, height, circle, className = "" }) => {
  const style = {
    width: width || "100%",
    height: height || "16px",
  };

  const skeletonClass = `v2-skeleton ${circle ? "v2-skeleton--circle" : ""} ${className}`.trim();

  return <div className={skeletonClass} style={style} />;
};

/**
 * Sidebar Menu Skeleton Loader
 * Shows loading state for menu items with icon and text
 */
export const SidebarMenuSkeleton = ({ count = 8, hasSubMenu = false }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index}>
          <div className="v2-sidebar-skeleton__menu-item">
            <Skeleton
              width="20px"
              height="20px"
              circle
              className="v2-sidebar-skeleton__icon"
            />
            <Skeleton className="v2-sidebar-skeleton__text" />
          </div>
          {hasSubMenu && index % 3 === 0 && (
            <div className="v2-sidebar-skeleton__submenu">
              <SidebarSubMenuSkeleton count={2} />
            </div>
          )}
        </div>
      ))}
    </>
  );
};

/**
 * Sidebar SubMenu Skeleton Loader
 */
export const SidebarSubMenuSkeleton = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="v2-sidebar-skeleton__submenu-item">
          <Skeleton className="v2-sidebar-skeleton__submenu-text" />
        </div>
      ))}
    </>
  );
};

export default Skeleton;
